exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customer-details .city-state-zip,.customer-details .country,.customer-details .line1,.customer-details .line2,.customer-details .name,.customer-details .phone{margin-bottom:5px}.customer-details .name{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.customer-details .edit-customer-link{color:#367c2b;cursor:pointer;margin-left:15px}.customer-details .edit-customer-link:hover{text-decoration:underline}.customer-details .email{cursor:pointer;margin-top:10px}.customer-details .email a{display:inline-block;overflow-wrap:break-word;word-wrap:break-word;font-size:.9rem;width:100%}.cf .customer-details .edit-customer-link,.cf .customer-details .email,.hitachi .customer-details .edit-customer-link,.hitachi .customer-details .email{color:#333;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/customer-search-panel/customer-details.scss
// module id = 5241
// module chunks = 0